module.exports = __webpack_public_path__ + "static/kartchen-kultur-gastro3-a4b2ee88f80d3c67725134d69cc825c2.png";